import React from 'react'
import { withRouter } from 'react-router-dom'
import qs from 'qs'
import {
  getPeriodNames,
  getSemester1BlockModelCalendarTypes,
  getSemester2BlockModelCalendarTypes,
  getSummerBlockModelClosingCalendarTypes,
  getSummerBlockModelCalendarTypes,
  getSemester1DualInstanceBlockModelCalendarTypes,
  getSemester2DualInstanceBlockModelCalendarTypes,
  getDualInstanceBlockWeek5CalendarTypes,
  getWinterBlockModelCalendarTypes
} from '../../../helpers/enrolment'
import {
  getStudyPeriodToSemesterName,
  getStudyPeriodWeightings
} from '../../../services/vu'
import { groupBy } from 'lodash'
import Loading from '../Loading'

class Summary extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      calendarTypes: [],
      studyPeriodWeightings: []
    }
  }

  componentDidMount() {
    Promise.all([
      getStudyPeriodWeightings(),
      getStudyPeriodToSemesterName()
    ]).then(([studyPeriodWeightings, studyPeriodToSemesterName]) => {
      this.setState({
        loading: false,
        studyPeriodWeightings: studyPeriodWeightings
      })
    })
  }

  handleTeachingPeriodSelect = (
    event,
    availabilityYear,
    studyPeriodCodes = []
  ) => {
    this.props.setAvailabilityYearAndStudyPeriods(
      availabilityYear,
      studyPeriodCodes
    )
    event.preventDefault()
  }

  buildCoursePattern = (title, studyPeriodCodes = [], availabilityYear) => {
    return {
      title: title,
      studyPeriodCodes: studyPeriodCodes,
      availabilityYear: availabilityYear
    }
  }

  isFirstYearWithPattern = () => {
    return this.props.prefillAttemptSuccessful
      && this.props.firstPass
  }

  isNotFirstYearWithPattern = () => {
    return !this.isFirstYearWithPattern()
  }

  renderBFYText = () => {
    if (
      this.isFirstYearWithPattern()
    ) {
      return this.getBFYMessage()
    }
  }

  renderBFYPrefillContinuingText = () => {
    if (this.props.prefillAttemptSuccessful && this.props.secondPass) {
      return this.getBFYContinuingPrefillMessage()
    }
  }

  getBFYMessage = () => (
    <div>
      <p>
        Your enrolment has been pre-filled with prescribed units to ensure you
        have met all of the requirements of your course and pattern of study.
        <br />
        Amendments to unit offerings can only be made after you have submitted
        your enrolment.
        <br />
        If you have any questions please contact{' '}
        <a
          href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres"
          target="_blank"
        >
          <strong>VUHQ</strong>
        </a>{' '}
      </p>
      <br />
    </div>
  )

  getBFYContinuingPrefillMessage = () => (
    <div>
      <p>
        Your enrolment for academic year {this.props.enrollingAcademicYear} has
        been pre-filled with one or more prescribed units to ensure you have met
        all of the requirements of your course and pattern of study.
      </p>
      {this.props.strictPattern ? (
        <p>
          Amendments to unit offerings can only be made after you have saved
          your enrolment.
        </p>
      ) : (
        <p>
          You can review, make amendments and enroll into other units to meet
          the requirements of your course.
        </p>
      )}
      <p>
        If you have any questions, please{' '}
        <a href="https://www.vu.edu.au/contact-us" target="_blank">
          contact VUHQ
        </a>
        .
      </p>
    </div>
  )

  getStudyPackages = () => {
    const studyPackages = this.props.studyPackages

    const studyPackagesByYear = groupBy(studyPackages, 'unitAvailabilityYear')
    return Object.keys(studyPackagesByYear).reduce(
      (a = [], unitAvailabilityYear) => {
        const flattenedValue = studyPackagesByYear[unitAvailabilityYear]
          .sort((a, b) => {
            if (
              this.getTeachingPeriodSortWeights(
                a.unitAvailabilityStudyPeriodCode
              ) <
              this.getTeachingPeriodSortWeights(
                b.unitAvailabilityStudyPeriodCode
              )
            ) {
              return -1
            }

            if (
              this.getTeachingPeriodSortWeights(
                a.unitAvailabilityStudyPeriodCode
              ) >
              this.getTeachingPeriodSortWeights(
                b.unitAvailabilityStudyPeriodCode
              )
            ) {
              return 1
            }

            return 0
          })
          .reduce(
            (
              b = [],
              { unitAvailabilityYear, unitAvailabilityStudyPeriodCode }
            ) => {
              const appendNewTeachingPeriod = (
                title,
                studyPeriodCodes = []
              ) => {
                if (
                  b.some(({ studyPeriodCodes = [] }) =>
                    studyPeriodCodes.includes(unitAvailabilityStudyPeriodCode)
                  )
                ) {
                  return b
                } else if (
                  b.some(
                    ({ title }) =>
                      title === getPeriodNames(unitAvailabilityStudyPeriodCode)
                  )
                ) {
                  let studyPeriodCodesWithNewTeachTypeAppended = b
                    .filter(
                      ({ title }) =>
                        title ===
                        getPeriodNames(unitAvailabilityStudyPeriodCode)
                    )[0]
                    .studyPeriodCodes.concat(studyPeriodCodes)
                  return b
                    .filter(
                      ({ title }) =>
                        title !==
                        getPeriodNames(unitAvailabilityStudyPeriodCode)
                    )
                    .concat(
                      this.buildCoursePattern(
                        title,
                        studyPeriodCodesWithNewTeachTypeAppended,
                        unitAvailabilityYear
                      )
                    )
                } else {
                  return b.concat(
                    this.buildCoursePattern(
                      title,
                      studyPeriodCodes,
                      unitAvailabilityYear
                    )
                  )
                }
              }
              if (
                getSemester1BlockModelCalendarTypes().includes(
                  unitAvailabilityStudyPeriodCode
                )
              ) {
                return appendNewTeachingPeriod(
                  getPeriodNames(unitAvailabilityStudyPeriodCode),
                  getSemester1BlockModelCalendarTypes()
                )
              }

              if (
                getSemester1DualInstanceBlockModelCalendarTypes().includes(
                  unitAvailabilityStudyPeriodCode
                )
              ) {
                return appendNewTeachingPeriod(
                  getPeriodNames(unitAvailabilityStudyPeriodCode),
                  getSemester1DualInstanceBlockModelCalendarTypes()
                )
              }

              if (
                getSemester2BlockModelCalendarTypes().includes(
                  unitAvailabilityStudyPeriodCode
                )
              ) {
                return appendNewTeachingPeriod(
                  getPeriodNames(unitAvailabilityStudyPeriodCode),
                  getSemester2BlockModelCalendarTypes()
                )
              }

              if (
                getSemester2DualInstanceBlockModelCalendarTypes().includes(
                  unitAvailabilityStudyPeriodCode
                )
              ) {
                return appendNewTeachingPeriod(
                  getPeriodNames(unitAvailabilityStudyPeriodCode),
                  getSemester2DualInstanceBlockModelCalendarTypes()
                )
              }

              if (
                getSummerBlockModelCalendarTypes().includes(
                  unitAvailabilityStudyPeriodCode
                )
              ) {
                return appendNewTeachingPeriod(
                  getPeriodNames(unitAvailabilityStudyPeriodCode),
                  getSummerBlockModelCalendarTypes()
                )
              }

              if (
                getWinterBlockModelCalendarTypes().includes(
                  unitAvailabilityStudyPeriodCode
                )
              ) {
                return appendNewTeachingPeriod(
                  getPeriodNames(unitAvailabilityStudyPeriodCode),
                  getWinterBlockModelCalendarTypes()
                )
              }

              if (
                getSummerBlockModelClosingCalendarTypes().includes(
                  unitAvailabilityStudyPeriodCode
                )
              ) {
                return appendNewTeachingPeriod(
                  'Summer (December start)',
                  getSummerBlockModelClosingCalendarTypes()
                )
              }

              if (
                getDualInstanceBlockWeek5CalendarTypes().includes(
                  unitAvailabilityStudyPeriodCode
                )
              ) {
                return appendNewTeachingPeriod(
                  getPeriodNames(unitAvailabilityStudyPeriodCode),
                  getDualInstanceBlockWeek5CalendarTypes()
                )
              }
              // return b
              return appendNewTeachingPeriod(
                getPeriodNames(unitAvailabilityStudyPeriodCode),
                [unitAvailabilityStudyPeriodCode]
              )
            },
            []
          )

        return a.concat(flattenedValue)
      },
      []
    )
  }

  getTeachingPeriodSortWeights = studyPeriodCode => {
    let studyPeriodWeighting = this.state.studyPeriodWeightings.filter(
      studyPeriodWeighting =>
        studyPeriodWeighting.studyPeriodCode === studyPeriodCode
    )

    return studyPeriodWeighting.length > 0
      ? studyPeriodWeighting[0].sortOrder
      : 1000
  }

  renderEnrolmentGuideContent = () => {
    const studyPackages = this.getStudyPackages()

    if (studyPackages.length === 0) {
      return <p>The Unit Enrolment Guide is currently unavailable.</p>
    }

    return (
      <div>
        {this.renderBFYText()}
        {this.renderBFYPrefillContinuingText()}
        {this.isNotFirstYearWithPattern() && (
          this.props.secondPass
            && this.props.strictPattern
            && !this.props.prefillAttemptSuccessful ? (
            <div>
              <p>
                Below are the unit offerings in your course that are available by
                teaching period. Please contact{' '}
                <a
                  href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres"
                  target="_blank"
                >
                  <strong>VUHQ</strong>
                </a>{' '}
                to discuss your study options.
              </p>
            </div>
          ) : (
            <div>
              <p>
                For help selecting <strong>block units</strong> for your
                enrolment, use this guide to check when classes are available.
              </p>
            </div>
          )
        )}

        {this.isNotFirstYearWithPattern() && (
          <ul className="teaching-periods">
            {studyPackages.map(
              ({ title, studyPeriodCodes, availabilityYear }, index) => {
                return (
                  <li key={index}>
                    <button
                      onClick={e =>
                        this.handleTeachingPeriodSelect(
                          e,
                          availabilityYear,
                          studyPeriodCodes
                        )
                      }
                      tabIndex={this.props.focusable ? 0 : -1}
                    >
                      <span>{availabilityYear}</span> - {title}
                    </button>
                  </li>
                )
              }
            )}
          </ul>
        )}
      </div>
    )
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    }
    return (
      <div className="enrolment-guide__content enrolment-guide__content--summary">
        <h1>Unit enrolment guide</h1>

        {this.renderEnrolmentGuideContent()}
      </div>
    )
  }
}

export default withRouter(Summary)
